import { createStore } from 'ice';
import user from './user';
import mn from './mn';

export default createStore({
  user,
  mn,
});
